// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__fx5aU","title":"ClientInsurance_title__3m5Mm","itemText":"ClientInsurance_itemText__2xZmY"};